'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dAllow$002dPayload from "./presto.types$-Allow-Payload.js";
import * as $j_presto$002etypes$0024$002dIp$002dPayload from "./presto.types$-Ip-Payload.js";
import * as $j_presto$002etypes$0024$002dTime$002dPayload from "./presto.types$-Time-Payload.js";
import * as $j_presto$002etypes$0024$002dWeek$002dDay$002dPayload from "./presto.types$-Week-Day-Payload.js";
import * as $j_presto$002etypes$0024proto$0024$0024anon$0024185 from "./presto.types$proto$$anon$185.js";
import * as $j_presto$002etypes$0024proto$0024$0024anon$0024186 from "./presto.types$proto$$anon$186.js";
import * as $j_presto$002etypes$0024proto$0024$0024anon$0024187 from "./presto.types$proto$$anon$187.js";
import * as $j_presto$002etypes$0024proto$0024$0024anon$0024191 from "./presto.types$proto$$anon$191.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$$anon$192(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$proto$$anon$192 as $c_Lpresto_types$proto$$anon$192 };
$p = $c_Lpresto_types$proto$$anon$192.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$$anon$192;
/** @constructor */
function $h_Lpresto_types$proto$$anon$192() {
}
export { $h_Lpresto_types$proto$$anon$192 as $h_Lpresto_types$proto$$anon$192 };
$h_Lpresto_types$proto$$anon$192.prototype = $p;
$p.a1 = (function(a) {
  if ((a instanceof $j_presto$002etypes$0024$002dAllow$002dPayload.$c_Lpresto_types$AllowPayload)) {
    return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(new $j_presto$002etypes$0024proto$0024$0024anon$0024185.$c_Lpresto_types$proto$$anon$185(), a);
  }
  if ((a instanceof $j_presto$002etypes$0024$002dIp$002dPayload.$c_Lpresto_types$IpPayload)) {
    return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(new $j_presto$002etypes$0024proto$0024$0024anon$0024186.$c_Lpresto_types$proto$$anon$186(), a);
  }
  if ((a instanceof $j_presto$002etypes$0024$002dTime$002dPayload.$c_Lpresto_types$TimePayload)) {
    return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(new $j_presto$002etypes$0024proto$0024$0024anon$0024187.$c_Lpresto_types$proto$$anon$187(), a);
  }
  if ((a instanceof $j_presto$002etypes$0024$002dWeek$002dDay$002dPayload.$c_Lpresto_types$WeekDayPayload)) {
    return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(new $j_presto$002etypes$0024proto$0024$0024anon$0024191.$c_Lpresto_types$proto$$anon$191(), a);
  }
  throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_MatchError(a);
});
var $d_Lpresto_types$proto$$anon$192 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$$anon$192, "presto.types$proto$$anon$192", ({
  a37: 1,
  a: 1,
  l: 1
}));
export { $d_Lpresto_types$proto$$anon$192 as $d_Lpresto_types$proto$$anon$192 };
//# sourceMappingURL=presto.types$proto$$anon$192.js.map
